<template>
  <section class="learning-area">
    <div
      class="learning-area__background"
      :style="
        `background-image: url(${backgroundImg(
          learningArea.name
        )}), linear-gradient(#151515, #262626);`
      "
    >
      <div class="learning-area__overlay"></div>
    </div>
    <article
      v-if="learningArea && learningArea.name"
      class="learning-area__category"
    >
      <div class="learning-area__details-wrapper">
        <h4 class="learning-area__type content-type">learning area</h4>
        <h4 class="learning-area__title content-title">
          <Passes
            :passName="learningArea.name"
            :size="50"
            class="learning-area__title--icon"
          />
          {{ learningArea.name }}
        </h4>
        <p class="learning-area__description content-description">
          {{ learningArea.description }}
        </p>
      </div>
      <AreaContent
        :learningAreaName="learningArea.name"
        :algoliaKeys="algoliaKeys"
        :isFreeTrialUser="isFreeTrialUser"
        :isShowingLearningPaths="learningArea.name !== 'Development'"
      />
      <div class="learning-area__search-wrapper">
        <AreaSearch
          :learningArea="learningArea.name"
          :algoliaKeys="algoliaKeys"
          :searchQuery="searchQuery"
          :filterMap="filterMap"
          :isAuthenticated="isAuthenticated"
          :isShowingLearningPaths="learningArea.name !== 'Development'"
          :isFreeTrialUser="isFreeTrialUser"
          :facets="facets"
          :features="features"
        />
      </div>
    </article>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AreaContent from '@/components/learning-area/AreaContent.vue'
import AreaSearch from '@/components/learning-area/AreaSearch.vue'
import Passes from '@/components/properties/Passes.vue'
import CONSTANTS from '@/constants'
export default {
  name: 'LearningArea',
  metaInfo() {
    const { learningArea } = this
    return {
      title:
        learningArea && learningArea.name
          ? `INE - ${learningArea.name}`
          : 'INE - Learning Areas',
      meta: [
        {
          vmid: 'learning-area',
          name: `description`,
          content:
            learningArea && learningArea.description
              ? learningArea.description
              : '',
        },
      ],
    }
  },
  components: {
    Passes,
    AreaContent,
    AreaSearch,
  },
  computed: {
    ...mapState({
      isPageLoading: state => state.app.isPageLoading,
      learningArea: state => state.learningAreas.currentLearningArea,
      algoliaKeys: state => state.search.algoliaKeys,
      features: state => state.search.features,
      facets: state => state.search.facets,
      searchQuery: state => state.search.searchQuery,
      filterMap: state => state.search.filterMap,
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
    ...mapGetters({
      isFreeTrialUser: 'auth/isFreeTrialUser',
    }),
  },
  methods: {
    backgroundImg(name) {
      const url = CONSTANTS.IMAGE_RULES.LEARNING_AREA_HEROES_URL
      const urlMap = {
        Cloud: `${url}/devops.jpg`,
        Networking: `${url}/networking.jpg`,
        Development: `${url}/development.jpg`,
        'Cyber Security': `${url}/security.jpg`,
        'IT Essentials': `${url}/general.jpg`,
        'Data Science': `${url}/data_science.jpg`,
      }
      return urlMap[name] || `${url}/devops.jpg`
    },
    queryData(areaId) {
      this.$store.dispatch('search/setQuery', '')
      this.$store.dispatch('learningAreas/getLearningArea', areaId)
    },
  },
  async created() {
    this.queryData(this.$route.params.id)
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.queryData(to.params.id)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.learning-area {
  background-color: var(--dark-gray);
  position: relative;
  &__background {
    width: 100%;
    height: 100vh;
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    z-index: 0;
    @include mobile {
      background-position: center;
    }
  }
  &__overlay {
    position: relative;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.4),
      var(--dark-gray),
      var(--dark-gray)
    );
    height: 100%;
    width: 100%;
    z-index: 0;
  }
  &__category {
    position: relative;
    padding: 150px 10px 0 10px;
    color: var(--white);
    max-width: 1900px;
    margin: 0 auto;
    @include tablet {
      padding: 150px 75px;
    }
  }
  &__title {
    margin-top: 9px;
    font-size: 2.5rem;
    display: flex;
    align-items: center;
    &--icon {
      margin-right: 20px;
    }
  }
  &__description {
    color: var(--white);
    padding-bottom: 100px;
    font-size: 1.2rem;
    @include mobile {
      width: 50%;
    }
  }
  &__search-wrapper {
    padding: 50px 0;
  }
}
</style>
